// // src/components/BoardPack/common/BoardPackControls.jsx
// import React, { useState, useEffect, useRef } from "react";
// import { Button } from "@/components/ui/button";
// import ReactSelect from "@/components/common/ReactSelect";
// import { apiCall } from "@/api/apiCall";
// import LoadingComponent from "@/components/common/LoadingComponent";
// import ErrorState from "@/components/common/ErrorStateComponent";
// import { CheckCircle, Download, X } from "lucide-react";

// const BoardPackControls = ({
//     selectedYear,
//     selectedMonth,
//     selectedContract,
//     selectedBoardPackConfig,
//     setSelectedBoardPackConfig,
//     onYearChange,
//     onMonthChange,
//     onContractChange,
//     onExportPDF,
//     onExportPPT,
//     onFinalizedBoardPack,
// }) => {
//     const [contracts, setContracts] = useState([]);
//     const [years, setYears] = useState([]);
//     const [months, setMonths] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);

//     const hasFetchedContract = useRef(false);

//     // Fetch contract, year, and month data from API
//     useEffect(() => {
//         if (hasFetchedContract.current) return;
//         hasFetchedContract.current = true;
//         const fetchData = async () => {
//             try {
//                 setLoading(true);
//                 const response = await apiCall("get", "/boardpack/contracts");

//                 if (response?.data) {
//                     const contracts = [
//                         {
//                             "name": "ALL COMPANIES",
//                             "uniqueName": "[Contract].[Contract].[ALL COMPANIES]",
//                             "caption": "ALL COMPANIES",
//                             "description": "All Companies"
//                         },
//                         {
//                             "name": "All Entities",
//                             "uniqueName": "[Contract].[Contract].[All Entities]",
//                             "caption": "All Entities",
//                             "description": "All Entities"
//                         },
//                         {
//                             "name": "Jeddah Airport Contract",
//                             "uniqueName": "[Contract].[Contract].[Jeddah Airport Contract]",
//                             "caption": "Jeddah Airport Contract",
//                             "description": "Jeddah Airport Contract"
//                         },

//                         {
//                             "name": "Sharjah Airport Parking",
//                             "uniqueName": "[Contract].[Contract].[2051001]",
//                             "caption": "2051001",
//                             "description": "Sharjah Airport Parking"
//                         },
//                         {
//                             "name": "Airport Jordan",
//                             "uniqueName": "[Contract].[Contract].[1200100]",
//                             "caption": "1200100",
//                             "description": "Airport Jordan"
//                         },
//                         {
//                             "name": "Lovers Mkt Off Str-dam",
//                             "uniqueName": "[Contract].[Contract].[0030015]",
//                             "caption": "0030015",
//                             "description": "Lovers Mkt Off Str-dam"
//                         },
//                         {
//                             "name": "Al Batha Contract",
//                             "uniqueName": "[Contract].[Contract].[Al Batha Contract]",
//                             "caption": "Al Batha Contract",
//                             "description": "Al Batha Contract"
//                         },
//                         {
//                             "name": "Dammam Airport Contract",
//                             "uniqueName": "[Contract].[Contract].[Dammam Airport Contract]",
//                             "caption": "Dammam Airport Contract",
//                             "description": "Dammam Airport Contract"
//                         },
//                         {
//                             "name": "TOTAL BILAL PROJECT",
//                             "uniqueName": "[Contract].[Contract].[TOTAL BILAL PROJECT]",
//                             "caption": "TOTAL BILAL PROJECT",
//                             "description": "Total Bilal Project"
//                         },
//                         {
//                             "name": "Bab Al-Ree Contract",
//                             "uniqueName": "[Contract].[Contract].[Bab Al-Ree Contract]",
//                             "caption": "Bab Al-Ree Contract",
//                             "description": "Bab Al-ree Contract"
//                         },
//                         {
//                             "name": "Gazzaz Contract",
//                             "uniqueName": "[Contract].[Contract].[Gazzaz Contract]",
//                             "caption": "Gazzaz Contract",
//                             "description": "Gazzaz Contract"
//                         },
//                         {
//                             "name": "Jed Watch Mkt-parking",
//                             "uniqueName": "[Contract].[Contract].[0020023]",
//                             "caption": "0020023",
//                             "description": "Jed Watch Mkt-parking"
//                         },
//                         {
//                             "name": "TOTAL DUBAI",
//                             "uniqueName": "[Contract].[Contract].[TOTAL DUBAI]",
//                             "caption": "TOTAL DUBAI",
//                             "description": "Total Dubai"
//                         },
//                         {
//                             "name": "Haram Contract",
//                             "uniqueName": "[Contract].[Contract].[Haram Contract]",
//                             "caption": "Haram Contract",
//                             "description": "Haram Contract"
//                         },
//                         {
//                             "name": "Taif Contract",
//                             "uniqueName": "[Contract].[Contract].[Taif Contract]",
//                             "caption": "Taif Contract",
//                             "description": "Taif Contract"
//                         },
//                         {
//                             "name": "Khamis Contract",
//                             "uniqueName": "[Contract].[Contract].[Khamis Contract]",
//                             "caption": "Khamis Contract",
//                             "description": "Khamis Contract"
//                         },
//                         {
//                             "name": "TOTAL JUBAIL",
//                             "uniqueName": "[Contract].[Contract].[TOTAL JUBAIL]",
//                             "caption": "TOTAL JUBAIL",
//                             "description": "Total Jubail"
//                         },
//                         {
//                             "name": "Hassa Contract",
//                             "uniqueName": "[Contract].[Contract].[Hassa Contract]",
//                             "caption": "Hassa Contract",
//                             "description": "Hassa Contract"
//                         },
//                         {
//                             "name": "CITY PARKING CO. LTD.",
//                             "uniqueName": "[Contract].[Contract].[CITY PARKING CO. LTD.]",
//                             "caption": "CITY PARKING CO. LTD.",
//                             "description": "City Parking Co. Ltd."
//                         },
//                         {
//                             "name": "Digital City Contract",
//                             "uniqueName": "[Contract].[Contract].[Digital City Contract]",
//                             "caption": "Digital City Contract",
//                             "description": "Digital City Contract"
//                         },
//                         {
//                             "name": "Baha Contract",
//                             "uniqueName": "[Contract].[Contract].[Baha Contract]",
//                             "caption": "Baha Contract",
//                             "description": "Baha Contract"
//                         },
//                         {
//                             "name": "Dammam Causeway",
//                             "uniqueName": "[Contract].[Contract].[Dammam Causeway]",
//                             "caption": "Dammam Causeway",
//                             "description": "Dammam Causeway"
//                         },
//                         {
//                             "name": "Baljurashi Contract",
//                             "uniqueName": "[Contract].[Contract].[Baljurashi Contract]",
//                             "caption": "Baljurashi Contract",
//                             "description": "Baljurashi Contract"
//                         },
//                         {
//                             "name": "Makkah Contract",
//                             "uniqueName": "[Contract].[Contract].[Makkah Contract]",
//                             "caption": "Makkah Contract",
//                             "description": "Makkah Contract"
//                         },
//                         {
//                             "name": "Jeddah Contract",
//                             "uniqueName": "[Contract].[Contract].[Jeddah Contract]",
//                             "caption": "Jeddah Contract",
//                             "description": "Jeddah Contract"
//                         },
//                     ];
//                     // Transform contract data: label = description, value = name
//                     // const contractOptions = response.data.contracts.map(item => ({
//                     //     label: item.description,
//                     //     value: item.name
//                     // }));

//                     // const contracts = response?.data?.contracts
//                     const contractOptions = contracts.map((item) => ({
//                         label: item.description,
//                         value: item.name,
//                     }));
//                     setContracts(contractOptions);

//                     // Transform year data: label = description, value = name
//                     const yearOptions = response.data.years.map((item) => ({
//                         label: item.description,
//                         value: item.name,
//                     }));
//                     setYears(yearOptions);

//                     // Transform month data: label = description, value = name
//                     const monthOptions = response.data.months.map((item) => ({
//                         label: item.description,
//                         value: item.name,
//                     }));
//                     setMonths(monthOptions);

//                     // Auto-select current year and month if not already selected
//                     // const currentDate = new Date();
//                     // const currentYear = "2026";
//                     // const currentMonthNum = "Feb";
//                     const currentDate = new Date();

//                     const currentYear = currentDate.getFullYear().toString();

//                     const currentMonthNum = currentDate.toLocaleString("en-US", {
//                         month: "short",
//                     });

//                     // Auto-select year if not already selected
//                     if (!selectedYear && yearOptions.length > 0) {
//                         const matchingYear = yearOptions.find((y) => y.value === currentYear);
//                         if (matchingYear) {
//                             onYearChange(matchingYear.value);
//                         } else {
//                             // If current year not found, select first year
//                             onYearChange(yearOptions[0].value);
//                         }
//                     }

//                     // Auto-select month if not already selected
//                     if (!selectedMonth && monthOptions.length > 0) {
//                         const matchingMonth = monthOptions.find((m) => m.value === currentMonthNum);
//                         if (matchingMonth) {
//                             onMonthChange(matchingMonth.value);
//                         } else {
//                             // If current month not found, select first month
//                             onMonthChange(monthOptions[0].value);
//                         }
//                     }
//                 }
//             } catch (err) {
//                 console.error("Error fetching dropdown data:", err);
//                 setError("Failed to load data");
//             } finally {
//                 setLoading(false);
//             }
//         };
//         fetchData();
//     }, []);

//     useEffect(() => {
//         const fetchData = async () => {
//             try {
//                 const response = await apiCall("get", "/boardpack/config/get", {
//                     contract: selectedContract,
//                 });
//                 if (response?.success) {
//                     setSelectedBoardPackConfig(response?.data);
//                 } else {
//                     setSelectedBoardPackConfig(null);
//                 }
//             } catch (error) {
//                 console.error(error);
//                 setError("Failed to load data");
//             }
//         };
//         if (selectedContract !== null) {
//             fetchData();
//         } else {
//             setSelectedBoardPackConfig(null);
//         }
//     }, [selectedContract]);

//     if (loading) {
//         return <LoadingComponent />;
//     }

//     if (error) {
//         return <ErrorState error={error} />;
//     }

//     return (
//         <div className="w-full px-4 sm:px-6 lg:px-10 ">
//             <div className="bg-muted border-2 border-border rounded-lg p-4 sm:p-5 lg:p-6">
//                 {/* Main Grid Layout */}
//                {/* Main Layout - flex instead of grid */}
// <div className="flex flex-wrap items-center gap-2">
//     {/* Year Dropdown */}
//     <div className="w-[130px]">
//         <ReactSelect
//             options={years}
//             value={selectedYear ? years.find((y) => y.value === selectedYear) : null}
//             onChange={(option) => onYearChange(option?.value)}
//             placeholder="Select Year"
//             isDisabled={loading}
//             width="100%"
//             className="w-full"
//         />
//     </div>

//     {/* Month Dropdown */}
//     <div className="w-[130px]">
//         <ReactSelect
//             options={months}
//             value={selectedMonth ? months.find((m) => m.value === selectedMonth) : null}
//             onChange={(option) => onMonthChange(option?.value)}
//             placeholder="Select Month"
//             isDisabled={loading}
//             width="100%"
//             className="w-full"
//         />
//     </div>

//     {/* Contract Dropdown */}
//     <div className="w-[220px] relative">
//         <ReactSelect
//             options={contracts}
//             value={selectedContract ? contracts.find((c) => c.value === selectedContract) : null}
//             onChange={(option) => onContractChange(option?.value)}
//             placeholder="Select Contract"
//             isDisabled={loading}
//             width="100%"
//             className="w-full"
//         />
//         {selectedContract && (
//             <button
//                 onClick={() => onContractChange(null)}
//                 className="absolute right-10 top-1/2 -translate-y-1/2 z-10 text-muted-foreground hover:text-destructive transition-colors"
//                 title="Clear contract"
//             >
//                 <X className="w-4 h-4" />
//             </button>
//         )}
//     </div>

//     {/* Export Buttons */}
//     <div className="flex items-center gap-2 ml-auto">
//         <Button
//             onClick={onFinalizedBoardPack}
//             className="flex items-center justify-center gap-2"
//             disabled={loading || !selectedYear || !selectedMonth || !selectedContract}
//             variant="outline"
//         >
//             <CheckCircle className="w-4 h-4" /> Finalized BoardPack
//         </Button>
//         <Button
//             onClick={onExportPDF}
//             className="flex items-center justify-center gap-2"
//             disabled={loading || !selectedYear || !selectedMonth || !selectedContract}
//             variant="outline"
//         >
//             <Download className="w-4 h-4" /> PDF
//         </Button>
//         <Button
//             onClick={onExportPPT}
//             className="flex items-center justify-center gap-2"
//             disabled={loading || !selectedYear || !selectedMonth || !selectedContract}
//             variant="outline"
//         >
//             <Download className="w-4 h-4" /> PowerPoint
//         </Button>
//     </div>
// </div>
//             </div>
//         </div>
//     );
// };

// export default BoardPackControls;
// src/components/BoardPack/common/BoardPackControls.jsx
import React, { useState, useEffect, useRef } from "react";
import { Button } from "@/components/ui/button";
import ReactSelect from "@/components/common/ReactSelect";
import { apiCall } from "@/api/apiCall";
import LoadingComponent from "@/components/common/LoadingComponent";
import ErrorState from "@/components/common/ErrorStateComponent";
import { CheckCircle, DownloadCloud, ListChecks, Loader2, RefreshCw, X } from "lucide-react";
import ExportOptionsPopup from "./ExportOptionsPopup";
import FinalizeRequestsPanel from "../FinalizeRequestsPanel";
import { useRecentJobs } from "@/hooks/useRecentJobs";
import { useActiveDownloads } from "@/hooks/useActiveDownloads";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useLocation } from "react-router-dom";
import { usePermissions } from "@/context/PermissionContext"; // ← NEW

// ─── Hardcoded BoardPack contracts (yeh fixed rehti hain) ────────────────────
const BOARDPACK_CONTRACTS = [
  { name: "ALL COMPANIES", description: "ALL COMPANIES" },
  { name: "Jeddah Airport Contract", description: "Jeddah Airport Contract" },
  { name: "Sharjah Airport Parking", description: "Sharjah Airport Parking" },
  { name: "Airport Jordan", description: "Airport Jordan" },
  { name: "Lovers Mkt Off Str-dam", description: "Lovers Mkt Off Str-dam" },
  { name: "Al Batha Contract", description: "Al Batha Contract" },
  { name: "Dammam Airport Contract", description: "Dammam Airport Contract" },
  { name: "TOTAL BILAL PROJECT", description: "TOTAL BILAL PROJECT" },
  { name: "Bab Al-Ree Contract", description: "Bab Al-Ree Contract" },
  { name: "Gazzaz Contract", description: "Gazzaz Contract" },
  { name: "Jed Watch Mkt-parking", description: "Jed Watch Mkt-parking" },
  { name: "TOTAL DUBAI", description: "TOTAL DUBAI" },
  { name: "Haram Contract", description: "Haram Contract" },
  { name: "Taif Contract", description: "Taif Contract" },
  { name: "Khamis Contract", description: "Khamis Contract" },
  { name: "TOTAL JUBAIL", description: "TOTAL JUBAIL" },
  { name: "Hassa Contract", description: "Hassa Contract" },
  { name: "Digital City Contract", description: "Digital City Contract" },
  { name: "Baha Contract", description: "Baha Contract" },
  { name: "Dammam Causeway", description: "Dammam Causeway" },
  { name: "Baljurashi Contract", description: "Baljurashi Contract" },
  { name: "Makkah Contract", description: "Makkah Contract" },
  { name: "Jeddah Contract", description: "Jeddah Contract" },
  { name: "MOC Contract", description: "MOC Contract" },
  { name: "Modern City Contract", description: "Modern City Contract" },
  { name: "CAPITAL PARKING CO. LTD", description: "CAPITAL PARKING CO. LTD" },
];

const BOARDPACK_OPTIONS = BOARDPACK_CONTRACTS.map((c) => ({
  label: c.description,
  value: c.description,
}));

const BoardPackControls = ({
  selectedYear,
  selectedMonth,
  selectedContract,
  selectedBoardPackConfig,
  setSelectedBoardPackConfig,
  onYearChange,
  onMonthChange,
  onContractChange,
  onExportPDF,
  onExportPPT,
  onFinalizedBoardPack,
  onRequestFinalize,
  isRequestingFinalize = false,
  boardPackJobs = {},
  onRefreshAll,
  isRefreshingAll = false,
  onConfigLoadingChange,
}) => {
  const [contracts, setContracts] = useState(BOARDPACK_OPTIONS); // starts with all hardcoded
  const [years, setYears] = useState([]);
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(true);
  const [configFetchLoading, setConfigFetchLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showExportPopup, setShowExportPopup] = useState(false);
  const [showFinalizeConfirm, setShowFinalizeConfirm] = useState(false);
  const [showRequests, setShowRequests] = useState(false);
  // Running exports / finalizes of any board pack, for the Requests button
  const { activeCount } = useRecentJobs();
  // PDF / PPTX downloads still in flight (also after the Requests dialog closed)
  const isDownloading = useActiveDownloads().size > 0;

  const location = useLocation();
  const hasFetched = useRef(false);

  // ── NEW: userContracts from context ──────────────────────────────────────
  const { userContracts, hasPermission } = usePermissions();
  const { activeExport, activeFinalize, latestExport } = boardPackJobs;

  // ── Step 1: Fetch years + months from API (contracts are hardcoded) ──────
  useEffect(() => {
    if (hasFetched.current) return;
    hasFetched.current = true;

    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await apiCall("get", "/boardpack/contracts");

        if (response?.data) {
          // Years
          const yearOptions = response.data.years.map((item) => ({
            label: item.description,
            value: item.name,
          }));
          setYears(yearOptions);

          // Months
          const monthOptions = response.data.months.map((item) => ({
            label: item.description,
            value: item.name,
          }));
          setMonths(monthOptions);

          // Auto-select current year
          const currentYear = new Date().getFullYear().toString();
          const currentMonth = new Date().toLocaleString("en-US", { month: "short" });

          if (!selectedYear && yearOptions.length > 0) {
            const match = yearOptions.find((y) => y.value === currentYear);
            onYearChange(match ? match.value : yearOptions[0].value);
          }

          if (!selectedMonth && monthOptions.length > 0) {
            const match = monthOptions.find((m) => m.value === currentMonth);
            onMonthChange(match ? match.value : monthOptions[0].value);
          }
        }
      } catch (err) {
        console.error("Error fetching dropdown data:", err);
        setError("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Step 2: Filter hardcoded contracts by userContracts["boardpack"] ─────
  useEffect(() => {
    if (!userContracts) {
      // Admin ya not loaded — sare hardcoded contracts dikhao
      setContracts(BOARDPACK_OPTIONS);
      return;
    }

    const allowedList = userContracts["boardpack"] ?? [];

    if (allowedList.length === 0) {
      // Kuch assign nahi — sab dikhao (fallback)
      setContracts(BOARDPACK_OPTIONS);
      return;
    }

    // Sirf wahi contracts dikhao jo assign hain
    const filtered = BOARDPACK_OPTIONS.filter((c) =>
      allowedList.some((a) => a.toLowerCase() === c.value.toLowerCase())
    );

    // Agar koi match nahi (mismatch?) toh sab dikhao
    setContracts(filtered.length > 0 ? filtered : BOARDPACK_OPTIONS);

    // Agar selected contract filtered list mein nahi hai toh reset karo
    if (selectedContract && !filtered.find((c) => c.value === selectedContract)) {
      onContractChange(null);
    }
  }, [userContracts]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Fetch boardpack config when contract changes ──────────────────────────
  useEffect(() => {
    const fetchConfig = async () => {
      setConfigFetchLoading(true);
      try {
        const response = await apiCall("get", "/boardpack/config/get", {
          contract: selectedContract,
        });
        if (response?.success) {
          setSelectedBoardPackConfig(response?.data);
        } else {
          setSelectedBoardPackConfig(null);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setConfigFetchLoading(false);
      }
    };

    if (selectedContract !== null) {
      fetchConfig();
    } else {
      setSelectedBoardPackConfig(null);
    }
  }, [selectedContract]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Report combined loading state to parent (bootstrap OR config fetch) ──
  useEffect(() => {
    onConfigLoadingChange?.(loading || configFetchLoading);
  }, [loading, configFetchLoading]); // eslint-disable-line react-hooks/exhaustive-deps

  if (loading) return <LoadingComponent />;
  if (error) return <ErrorState error={error} />;

  return (
    <div className="">
      <div className="bg-muted border-2 border-border rounded-lg p-3">
        <div className="flex flex-wrap items-center gap-2">
          {/* Year */}
          <div className="w-[130px]">
            <ReactSelect
              options={years}
              value={selectedYear ? years.find((y) => y.value === selectedYear) : null}
              onChange={(option) => onYearChange(option?.value)}
              placeholder="Select Year"
              isDisabled={loading}
              width="100%"
            />
          </div>

          {/* Month */}
          <div className="w-[130px]">
            <ReactSelect
              options={months}
              value={selectedMonth ? months.find((m) => m.value === selectedMonth) : null}
              onChange={(option) => onMonthChange(option?.value)}
              placeholder="Select Month"
              isDisabled={loading}
              width="100%"
            />
          </div>

          {/* Contract — hardcoded list, filtered by userContracts */}
          <div className="w-[250px] relative">
            <ReactSelect
              options={contracts}
              value={selectedContract ? contracts.find((c) => c.value === selectedContract) : null}
              onChange={(option) => onContractChange(option?.value)}
              placeholder="Select Contract"
              isDisabled={loading}
              width="100%"
            />
            {selectedContract && (
              <button
                onClick={() => onContractChange(null)}
                className="absolute right-10 top-1/2 -translate-y-1/2 z-10 text-muted-foreground hover:text-destructive transition-colors"
                title="Clear contract"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>

          {/* Refresh + Export buttons */}
          {location.pathname !== "/board-pack-mobile" && (
            <div className="ml-auto flex items-center gap-2">
              <Button
                onClick={() => setShowRequests(true)}
                className="flex items-center justify-center gap-2"
                variant="outline"
                title="Exports and finalizes running in the background or ready to download"
              >
                {activeCount > 0 || isDownloading ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <ListChecks className="w-4 h-4" />
                )}
                Requests
                {activeCount > 0 && (
                  <span className="text-xs font-medium bg-blue-50 text-blue-600 px-1.5 py-0.5 rounded-full">
                    {activeCount}
                  </span>
                )}
              </Button>
              <Button
                onClick={onRefreshAll}
                className="flex items-center justify-center gap-2"
                disabled={
                  loading || isRefreshingAll || !selectedYear || !selectedMonth || !selectedContract
                }
                variant="outline"
              >
                {isRefreshingAll ? (
                  <Loader2 className="w-4 h-4 animate-spin" />
                ) : (
                  <RefreshCw className="w-4 h-4" />
                )}
                Refresh Complete BoardPack
              </Button>
              <Button
                onClick={() => setShowExportPopup(true)}
                className="flex items-center justify-center gap-2"
                disabled={loading || !selectedYear || !selectedMonth || !selectedContract}
                variant="outline"
                title={activeExport ? "An export of this board pack is being generated" : undefined}
              >
                {activeExport ? (
                  <>
                    <Loader2 className="w-4 h-4 animate-spin" /> Exporting… {activeExport.progress || 0}%
                  </>
                ) : (
                  <>
                    <DownloadCloud className="w-4 h-4" /> Export
                  </>
                )}
              </Button>
              {/* {onRequestFinalize && hasPermission("mark_finalized_boarpack") && (
                <Button
                  onClick={() => setShowFinalizeConfirm(true)}
                  className="flex items-center justify-center gap-2"
                  disabled={
                    loading ||
                    isRequestingFinalize ||
                    Boolean(activeFinalize) ||
                    !selectedYear ||
                    !selectedMonth ||
                    !selectedContract
                  }
                  title={activeFinalize ? "This board pack is being finalized in the background" : undefined}
                >
                  {isRequestingFinalize || activeFinalize ? (
                    <Loader2 className="w-4 h-4 animate-spin" />
                  ) : (
                    <CheckCircle className="w-4 h-4" />
                  )}
                  {activeFinalize ? `Finalizing… ${activeFinalize.progress || 0}%` : "Finalize"}
                </Button>
              )} */}
            </div>
          )}
        </div>
      </div>

      {/* Export Popup — sirf ek baar */}
      <ExportOptionsPopup
        isOpen={showExportPopup}
        onClose={() => setShowExportPopup(false)}
        onExportPDF={onExportPDF}
        onExportPPT={onExportPPT}
        activeExport={activeExport}
        latestExport={latestExport}
      />

      {/* <Dialog open={showRequests} onOpenChange={setShowRequests}>
        <DialogContent className="sm:max-w-2xl max-h-[85vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Export Activites</DialogTitle>
            <DialogDescription>
              The latest request of each board pack — running ones show their progress, ready
              exports can be downloaded here.
            </DialogDescription>
          </DialogHeader>
          <FinalizeRequestsPanel
            title="Latest requests"
            emptyText="No exports or finalizes yet."
            className=""
          />
        </DialogContent>
      </Dialog> */}
      <Dialog open={showRequests} onOpenChange={setShowRequests}>
  <DialogContent className="sm:max-w-2xl max-h-[85vh] flex flex-col overflow-hidden">
    <DialogHeader className="shrink-0">
      <DialogTitle>Export Activities</DialogTitle>
      <DialogDescription>
        The latest request of each board pack — running ones show their progress, ready
        exports can be downloaded here.
      </DialogDescription>
    </DialogHeader>
    <FinalizeRequestsPanel
      title="Latest requests"
      emptyText="No exports or finalizes yet."
      className="flex flex-col flex-1 min-h-0"
      listClassName="flex-1 min-h-0 overflow-y-auto"
    />
  </DialogContent>
</Dialog>

      <Dialog open={showFinalizeConfirm} onOpenChange={setShowFinalizeConfirm}>
        <DialogContent className="sm:max-w-md">
          <DialogHeader>
            <DialogTitle>Finalize board pack?</DialogTitle>
            <DialogDescription>
              {selectedContract} — {selectedMonth} {selectedYear}. The server will generate the PDF
              and PowerPoint and mark them as finalized. You can leave this screen or close the
              browser; you'll find the files under Finalized BoardPacks.
            </DialogDescription>
          </DialogHeader>
          <DialogFooter>
            <Button variant="outline" onClick={() => setShowFinalizeConfirm(false)}>
              Cancel
            </Button>
            <Button
              onClick={() => {
                setShowFinalizeConfirm(false);
                onRequestFinalize?.();
              }}
            >
              <CheckCircle className="w-4 h-4 mr-2" />
              Send request
            </Button>
          </DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default BoardPackControls;
